import { render } from "./ClosedObligations.vue?vue&type=template&id=58393214&scoped=true&ts=true"
import script from "./ClosedObligations.vue?vue&type=script&lang=ts"
export * from "./ClosedObligations.vue?vue&type=script&lang=ts"

import "./ClosedObligations.vue?vue&type=style&index=0&id=58393214&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58393214"]])

export default __exports__